/** Fresh detail visits start at the top; history and list returns keep scroll. */
export function shouldRestoreScroll(navigationType: 'POP' | 'PUSH' | 'REPLACE', pathname: string): boolean {
  if (pathname === '/tools' || pathname.startsWith('/tools/')) return false;
  return navigationType !== 'PUSH' || pathname.split('/').filter(Boolean).length <= 1;
}
